import styles from "./style.module.scss";
import clsx from "clsx";
import { Link } from "react-router-dom";
const Toggle = ({ toggle, handleOpenToggle }: any) => {
  const toggleStyle = clsx({
    [styles.overlayClick]: toggle === true,
    [styles.overlay]: toggle === false,
  });

  return (
    <div id="myNav" className={toggleStyle}>
      <a href="#!" className={styles.closebtn} onClick={handleOpenToggle}>
        &times;
      </a>
      <div className={styles["overlay-content"]}>
        <ul>
          <div onClick={handleOpenToggle}>
            <Link to="/">
              <li>
                <span>Anasayfa</span>
              </li>
            </Link>
            <Link to="/sayac-verileri">
              <li>
                <span>Sayaç Verileri</span>
              </li>
            </Link>
            <Link to="/kullanici-islemleri">
              <li>
                <span>Kullanıcı İşlemleri</span>
              </li>
            </Link>
            <Link to="/helper">
              <li>
                <span>Yardım</span>
              </li>
            </Link>
            <Link to="">
              <li>
                <span>Çıkış Yap</span>
              </li>
            </Link>
          </div>
        </ul>
      </div>
    </div>
  );
};

export default Toggle;
